<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("checklists", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $t("manageAllyourchecklistshere") }}
        </div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Checklists')"
          variant="default"
          :to="{ name: 'Add Checklist' }"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getChecklists"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container">
      <div class="desg-list-header">
        <div class="pr-5" style="width:120px">{{ $tc("status", 2) }}</div>
        <div>
          <img
            v-if="this.columnName != 'checklist_name'"
            @click="onSortValue('checklist_name', 'asc')"
            src="@/assets/img/icons/updown.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else-if="isSort && isAscending"
            @click="onSortValue('checklist_name', 'asc')"
            src="@/assets/img/icons/asc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else
            @click="onSortValue('checklist_name', 'desc')"
            src="@/assets/img/icons/desc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          {{ $tc("checklists", 2) }}
        </div>
      </div>
      <ul v-if="checklists && checklists.length > 0" class="desg-list">
        <li
          v-for="(checklist, checklistLoopKey) in checklists"
          :key="checklistLoopKey"
        >
          <!-- <div class="d-flex align-items-center">
            <label class="ios-switch">
              <input
                v-model="checklist.checklist_is_active"
                value="Y"
                disabled
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label>
            <b-dropdown right variant="edit" class="ml-4">
              <b-dropdown-item
                v-if="$can('update', 'Checklists')"
                :to="{
                  name: 'Edit Checklist',
                  params: { checklist_id: checklist.checklist_id },
                }"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'View Checklist',
                  params: { checklist_id: checklist.checklist_id },
                }"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }}
              </b-dropdown-item>
            </b-dropdown>
          </div> -->
          <div class="d-flex align-items-center" style="width:120px">
            <b-checkbox
              v-model="checklist.checklist_is_active"
              value="Y"
              disabled
              type="checkbox"
              class="j-checkbox"
            />
            <router-link
              v-if="$can('update', 'Checklists')"
              :to="{
                name: 'Edit Checklist',
                params: { checklist_id: checklist.checklist_id },
              }"
              class="ml-2"
            >
              <i
                class="edit-pen blue-icon cursor-pointer"
                v-b-tooltip="'Edit'"
              ></i>
            </router-link>

            <router-link
              :to="{
                name: 'View Checklist',
                params: { checklist_id: checklist.checklist_id },
              }"
              class="ml-2"
            >
              <i
                class="icon-eye blue-icon cursor-pointer"
                v-b-tooltip="'View'"
              ></i>
            </router-link>
          </div>

          <div>{{ checklist.checklist_name }}</div>
        </li>
      </ul>

      <div class="pb-3" v-else>
        <NoRecords class="mb-0" />
      </div>
    </div>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import ChecklistService from "@/services/ChecklistService";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      checklists: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: null,
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "desc",
      columnName: "created_at",

      debounce: null,
      searchValue: "",
    };
  },
  mounted() {
    this.getChecklists();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getChecklists();
    },
    getChecklists() {
      ChecklistService.GetChecklists({
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.checklists = data.Records;
            console.log("this.checklists :>> ", this.checklists);
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getChecklists();
      } else {
        this.currentPage = event;
        this.getChecklists();
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 4 },
        { name: "40", id: 5 },
        { name: "50", id: 6 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ChecklistComponents/listChecklists.vue